import React from 'react'
import Sidebar from '../../../Sidebar'
import Navbar from '../../../Navbar'

const LDPStart = () => {
  return (
    <>
      <Sidebar/>
        <div className="main">
          <div className="topbar">
            <Navbar title="LDP Start For All Colleges"/>
          </div>
        </div>
    </>
  )
}

export default LDPStart
